import { render } from "./UpdateEmailForm.vue?vue&type=template&id=821af800&scoped=true&ts=true"
import script from "./UpdateEmailForm.vue?vue&type=script&lang=ts"
export * from "./UpdateEmailForm.vue?vue&type=script&lang=ts"

import "./UpdateEmailForm.vue?vue&type=style&index=0&id=821af800&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-821af800"]])

export default __exports__